/*
 * Version 1.1
 * @author Jonathan Sharp
 * This treeview component was originally based upon the Treeview jQuery plugin by Jörn Zaefferer
 * http://bassistance.de/jquery-plugins/jquery-plugin-treeview/
 * http://docs.jquery.com/Plugins/Treeview
 *
 */
(function($) {
	// This method initializes a tree
	$.fn.originTreeview = function(settings) {
		settings = $.extend({
			cascadeCheck: true
		}, settings || {});
		
		// Handle tree events via event delegation
		$(this).filter('ul')
			.addClass('treeview')
			.data('settings', settings)
			.bind('click', function(evt) {
				if ( $(evt.target).hasClass('control') ) {
					$(evt.target).originTreeviewToggle();
					return false;
				}
			})
			.originTreeviewLoad()
			.If( settings.cascadeCheck == true )
				.bind('change', function treeviewChangeHandler(evt) {
					var checked = $(evt.target).is(':checked');
					log('change event: ' + evt.target.tagName + ' ' + ( checked ? 'CHECKED' : 'UNCHECKED' ) );
					// Process all of the children
					$(evt.target)
						.closest('li')
							.trigger('treeview' + ( checked ? 'selected' : 'unselected' ), [ $(evt.target).closest('li')[0] ] )
							.find(':checkbox')
								.not(evt.target)
								.each(function() {
									var status = $(this).is(':checked');
									if ( status != checked ) {
										$(this)[ checked ? 'attr' : 'removeAttr' ]('checked', 'checked')
											.closest('li')
												.trigger('treeview' + ( checked ? 'selected' : 'unselected' ), [ $(evt.target).closest('li')[0] ] );
									}
								});
					// Process the parents
					$(evt.target)
						.parents('li')
							.slice(1).each(function() {
								var _this = this;
								var checkbox = $(this).find(':checkbox').filter(function() {
														return _this === $(this).closest('li')[0];
													});
								var status = checkbox.is(':checked');
								
								if ( !checked ) {
									// Only trigger the event if the checkbox is not already checked
									if ( status != checked ) {
										checkbox.removeAttr('checked');
										$(this).trigger('treeviewunselected', [ $(evt.target).closest('li')[0] ] );
									}
								} else {
									var children = $(this).find(':checkbox').not( checkbox );
									var allChecked = children.filter(':checked').length == children.length;
									// Only trigger the event if the current checkbox state is going to change
									if ( allChecked != status ) {
										checkbox[ allChecked ? 'attr' : 'removeAttr' ]('checked', 'checked');
										$(this).trigger('treeview' + ( allChecked  ? 'selected' : 'unselected' ), [ $(evt.target).closest('li')[0] ] );
									}
								}
							});
				})
				// So IE 6-8 really is a big pain in that change events don't bubble. So here we use a propriatary 
				// 'focusin' event to initialize a behavior on focus
				.If( $.browser.msie )
					.bind('focusin', function(evt) {
						var target = $(evt.target).filter(':checkbox');
						if ( target.data('treeviewchange') !== true ) {
							target.data('treeviewchange', true).bind('click', function() {
								treeviewChangeHandler({ target: this });
							});
						}
					});
		return this;
	};
	
	
	
	function refreshNode() {
		var $t = $(this);
		var expanded = $t.hasClass('expanded');
		if ( !expanded ) {
			$t.addClass('collapsed');
		}
		if ( $t.find('> ul,> div.control').length == 1 ) {
			$('<div class="control" />').prependTo( $t );
		}
	}
	
	function refreshTree() {
		$(this)
			.find('> li > ul')
				.parent()
					.each( refreshNode )
				.end()
				.each( refreshTree )
			.end()
			.find('> li.last')
				.not(':last-child')
					.removeClass('last lastExpanded lastCollapsed')
				.end()
			.end()
			.find('> li:last-child')
				.addClass('last')
				.find('> ul')
					.parent()
						.filter('.collapsed')
							.addClass('lastCollapsed')
						.end()
						.filter('.expanded')
							.addClass('lastExpanded');
	}
	
	// This method will take LIs in the treeview and set the parents count
	// The LI passed in should have a correct count set first if it is dynmic
	$.fn.setParentsSelectedCount = function () {
		return this.each( function () {
			var $parent = $(this).closest('ul').closest('li');
			var totalCount = 0;
			$parent.find('> ul > li').each(function () {
				var $li = $(this);
				var myCount = 0;						
				if( $li.is('.dynamic') ) { //if its dynamic get the count from the label
					myCount = parseInt( $li.find('> label > em > span').text(), 10 ) || 0;
				} else if ( $li.find('> label.inline :checkbox').is(':checked') ) { //otherwise its one if its checked
					myCount = 1;
				}
				totalCount += myCount;						
			});
			$parent.find('> label > em > span').text(totalCount);
			$parent.setParentsSelectedCount();
		});
	};
	
	// This method should be called on the tree or branch to initialize 
	// any elements such as the expand + and -
	$.fn.originTreeviewRefresh = function() {
		$(this).closest('ul').each( refreshTree );
		return this;
	};
	
	// Given a UL, will load any child nodes from the url contained in the 
	// data-src="" html attribute, optionally you can specify the url as the 
	// first parameter to load from
	$.fn.originTreeviewLoad = function(url, triggerEvent) {
		if ( arguments.length == 1 && ( url === true || url === false ) ) {
			triggerEvent = url;
			url = undefined;
		}
		this.filter('ul').each(function() {
			var src = url || $(this).dataset('src');
			if ( src ) {
				$(this).removeDataset('src');
				$('<li></li>').addInlineLoading('Loading...').appendTo( this );
				
				var $li = $(this).closest('li');
				var ck = $li.find(':checkbox').is(':checked');
				
				var postData = $(this).dataset('post') || '';
				postData += ( postData != '' ? '&' : '' ) + 'checkAll=' + ck;
				
				var _this = this;
				$.post( src, postData, function(html) {
					// We are the top level tree, so don't replace the UL, just
					// append our children to it
					if ( $(_this).hasClass('treeview') ) {
						$(_this).empty();
						$(html).find('> li').appendTo( _this ).originTreeviewRefresh();
						// Trigger children loaded event
						$(_this).trigger('treeViewChildrenLoaded');
					} else {
						$(html).replaceAll( _this ).originTreeviewRefresh();
						// Trigger children loaded event
						$li.trigger('treeViewChildrenLoaded');
					}
					if ( triggerEvent !== false ) {
						var isExpanded = $li.hasClass('expanded');
						$(_this).closest('li').trigger( isExpanded ? 'treeviewcollapsed' : 'treeviewexpanded' );
					}
				}, 'html' );
			} else {
				$(this).originTreeviewRefresh();
			}
		});
		return this;
	};
	
	// Toggles expanding or collapsing a branch
	$.fn.originTreeviewToggle = function(force, triggerEvent) {
		return this.each(function() {
			log('Toggling');
			var $li = $(this).closest('li');
			var isExpanded = $li.hasClass('expanded');
			
			log('force: ' + force + ' isExpanded: ' + isExpanded);
			
			if ( ( force === true && !isExpanded ) || ( force === false && isExpanded ) || !( force === true || force === false ) ) {
				var expand = ( force === true || force === false ) ? force : !isExpanded;
				log('Expand? ' + expand);
				$li	.toggleClass('expanded', expand).toggleClass('collapsed', !expand)
					.filter('.last').toggleClass('lastExpanded', expand).toggleClass('lastCollapsed', !expand);
			}
			
			var $ul = $li.find('> ul');
			var src = $ul.dataset('src');
			if ( src ) {
				$ul.originTreeviewLoad( triggerEvent );
			} else if ( triggerEvent !== false ) {
				$li.trigger( isExpanded ? 'treeviewcollapsed' : 'treeviewexpanded' );
			}
		});
	};
	
	// Method walks the tree and opens all parents revealing this child
	$.fn.originTreeviewRevealNode = function(triggerEvent) {
		this.filter('li').each(function() {
			$(this).parents().each(function() {
				if ( $(this).is('ul.treeview') ) {
					return false;
				} else if ( $(this).is('li') ) {
					$(this).originTreeviewToggle( true, triggerEvent );
				}
			});
		});
		return this;
	};
	
	// Inserts one or more nodes at the current point of interaction
	$.fn.originTreeviewInsert = function(node) {
		return this.each(function() {
			var $node = $(node);
			var $t = $(this);
			if ( $t.is('ul') ) {
				if ( $node.is('li') ) {
					$node.appendTo( $t );
				} else if ( $node.is('ul') ) {
					$node.find('> li').appendTo( $t );
				}
				$t.originTreeviewRefresh();
			} else {
				var li = $(this).closest('li');
				if ( $node.is('li') ) {
					$node.insertAfter( li );
				} else if ( $node.is('ul') ) {
					var ul = li.find('> ul');
					if ( ul.length == 1 ) {
						$node.find('> li').appendTo( ul );
					} else {
						$node.appendTo( ul );
					}
					li.parent().originTreeviewRefresh();
				}
			}
		});
	};
	
	// Removes the specified node in the tree
	$.fn.originTreeviewRemove = function() {
		var removed = [];
		this.each(function() {
			var $li = $(this).closest('li');
			var $parent = $li.parent();
			$li.remove();
			$.merge( removed, $li.get(0) );
			$parent.trigger('treeviewremoved', [ $li.get(0) ] );
		});
		return this.pushStack( removed );
	};
})(jQuery);